import React, { useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import DataGrid from "components/DataGrid/DataGrid";
import { PostAPI } from "api/post";
import { transformColumns } from "utilities/CommonUtils";
import "./ExpandRowGrid.css";
import { Box } from '@mui/material';

const cookies = new Cookies();

const ExpandRowGrid = ({ pageLayoutData, serachFliterBoxData, dynamicParameters, response, row, values, pagination, setPagination, title, productsData, expandRow, endpoint }) => {
    const [rowData, setRowData] = useState([])
    const [columns, setColumns] = useState([])
    const [totalrecords, setTotalrecords] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchTableData = async () => {
        if (pageLayoutData[1].title1 === "Delivery") {
            if (row?.parentData?.data?.length > 0) {
                setColumns(row?.parentData?.columns);
                setRowData(row?.parentData?.data)
                setTotalrecords(row?.parentData?.length)
            }
            return;
        }
        setIsLoading(true);
        let payLoad = {}
        const getURL = endpoint ? endpoint : title === "Ageing Report" ? pageLayoutData[1].subComponentsItems.apiEndPoint1 : pageLayoutData[1].subComponentsItems.apiEndPoint2;
        if (pageLayoutData[1].subComponentsItems.extraParameters !== null) {
            const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
            payLoad = { ...payLoad, ...extraParameteres }
        }
        if (pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
            const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
            payLoad = { ...payLoad, ...firstTimeParameters }
        }

        let fmData = serachFliterBoxData(values);
        payLoad = { ...payLoad, ...dynamicParameters, ...fmData }

        for (let i = 0; i < response.length; i++) {
            if (response[i].name === row.name) {
                payLoad = {
                    ...payLoad,
                    specificProductId: response[i].productId,
                    specificLocationId: response[i].locationId,
                    ...(response[i].mfg_in ? { mfg_date: response[i].mfg_in } : {})
                }
            }
        }
        const responseData = await PostAPI(getURL, payLoad);
        if (responseData.status == 200) {
            setIsLoading(false)
            let responseDataJson = await responseData.data;
            const ageingData = responseDataJson.data.data.map(data => ({ ...data, title: title }))
            setRowData(ageingData);
            setColumns(responseDataJson.data.columns);
            setTotalrecords(responseDataJson.data.expandRowTotalrecords);
        } else {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        fetchTableData();
    }, [])

    return (
        <Box sx={{ width: '100%', height: '100vh', padding: 2 }}>
            <DataGrid
                className="expand-grid-styles"
                rowData={rowData}
                columns={transformColumns(columns)}
                paginationConfig={{ totalrecords, pagination, setPagination, enablePagination: false }}
                title={title}
                isTitle={true}
                isLoading={isLoading}
                globalSearchConfig={{enableGlobalFilter: false}}
                filterConfig={{enableColumnFilters: false}}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableHiding={false}
                rowExpandConfig={{
                    enableRowExpansion: (title === "Bin Location" || cookies.get("customer_id") == 17) ? false : true,
                    expandRow: {
                        renderer: (expandedRow) => {
                            if (expandedRow.original.childData?.length > 0) {
                                return (<>{expandRow.renderer(expandedRow)}</>)
                            } else if (title === "Bin Location") {
                                return null;
                            } else {
                                return <ExpandRowGrid
                                    pageLayoutData={pageLayoutData}
                                    serachFliterBoxData={serachFliterBoxData}
                                    dynamicParameters={dynamicParameters}
                                    response={rowData}
                                    row={expandedRow.original}
                                    values={values}
                                    pagination={pagination}
                                    setPagination={setPagination}
                                    title={"Bin Location"}
                                    isTitle={true}
                                    enableTopToolbar={false}
                                />
                            }
                        },
                    },
                }}
            />
        </Box>
    )
}


export default React.memo(ExpandRowGrid);